import 'scss/services/keyword-extraction.scss'
import 'babel-polyfill'
import {
  serviceTopbar
} from 'js/libs/utils-services'
import { config } from 'config'
import { productKesa } from 'js/api/services'
import 'js/libs/gt'

var demoTextList = [
  '讯飞开放平台作为开放的智能交互技术服务平台，致力于为开发者打造一站式智能人机交互解决方案。',
  '人工智能是一门极富挑战性的科学，从事这项工作的人必须懂得计算机知识，心理学和哲学。',
  'AI大学堂是由讯飞开放平台打造的人工智能专业学习、交流和培训的AI学习平台。作为国内AI在线学习平台，旨在为 AI 领域开发者、爱好者提供丰富的资源、专业的课程以及共享的服务。'
]
var n = 0

var mnData = [
  [{score: '0.651', word: '智能'}, {score: '0.651', word: '交互'}, {score: '0.650', word: '平台'}, {score: '0.645', word: '讯飞'}, {score: '0.629', word: '一站式'}, {score: '0.625', word: '开发者'}, {score: '0.617', word: '开放'}, {score: '0.614', word: '人机'}, {score: '0.605', word: '致力'}, {score: '0.603', word: '方案'}],
  [{score: '0.641', word: '挑战性'}, {score: '0.636', word: '人工智能'}, {score: '0.616', word: '心理学'}, {score: '0.607', word: '哲学'}, {score: '0.602', word: '计算机'}, {score: '0.596', word: '科学'}, {score: '0.593', word: '知识'}, {score: '0.571', word: '从事'}, {score: '0.558', word: '工作'}, {score: '0.540', word: '懂得'}],
  [{score: '0.631', word: '平台'}, {score: '0.618', word: 'AI'}, {score: '0.590', word: '人工智能'}, {score: '0.586', word: '开发者'}, {score: '0.580', word: '学习'}, {score: '0.576', word: '专业'}, {score: '0.575', word: '爱好者'}, {score: '0.567', word: '共享'}, {score: '0.565', word: '领域'}, {score: '0.564', word: '课程'}]
]

var functionalExperienceModel = {
  result: {},
  // 增加极验
  geetestApi1: function () {
    var that = this
    var config = this.config
    $.ajax({
      url: '/herapi/plug/validate?t=' + (new Date()).getTime(),
      type: 'get',
      dataType: 'json',
      success: function (data) {
        // 调用 initGeetest 进行初始化
        // 参数1：配置参数
        // 参数2：回调，回调的第一个参数验证码对象，之后可以使用它调用相应的接口
        initGeetest({
          // 以下 4 个配置参数为必须，不能缺少
          gt: data.data.gt,
          challenge: data.data.challenge,
          offline: !data.data.success, // 表示用户后台检测极验服务器是否宕机
          new_captcha: data.data.new_captcha, // 用于宕机时表示是新验证码的宕机
          product: 'bind', // 产品形式，包括：float，popup
          width: '300px'
          // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
        }, function (captchaObj) {
          captchaObj.onReady(function () {
          }).onSuccess(function () {
            that.result = captchaObj.getValidate()
            if (!that.result) {
              return alert('请完成验证')
            }
            that.analysis()
          })
          // 开始分析
          $('#startLoad').on('click', function () {
            if (that.checkTextarea()) {
              captchaObj.verify()
            }
          })
        })
      }
    })
  },
  analysis: function (isDemo) {
    var that = this
    if (isDemo) {
      that.render(mnData[n])
    } else {
      if (that.checkTextarea()) {
        var params = {
          challenge: that.result.geetest_challenge,
          validate: that.result.geetest_validate,
          seccode: that.result.geetest_seccode,
          text: that.checkTextarea(),
          type: 'ke'
        }
        $.mask()
        productKesa(params).then(function (result) {
          $.mask('hide')
          if (result.flag && result.data === null) {
            $('#analysis-result li').not('.analysis-result-title').remove()
          }
          if (result.flag && result.data) {
            that.render(result.data.ke)
          } else if (result.code === '99999' || result.code === 99999) {
            $.alerts.alert('系统异常，请稍后再试')
          } else if (result.code === '20011' || result.code === 20011) {
            $.alerts.alert('验证码校验不通过')
          }
        })
      }
    }
  },
  render: function (res) {
    var that = this
    var analysisResultTmpl = `<li class="analysis-result-title"><div>名称</div><div>权重</div></li>`
    for (var i = 0; i < res.length; i++) {
      analysisResultTmpl += `<li><div>${res[i].word}</div><div>${res[i].score}</div></li>`
    }
    $('#analysis-result').empty().html(analysisResultTmpl)
  },
  // 切换示例文本
  changeDemo: function () {
    if (n >= (demoTextList.length - 1)) {
      n = 0
    } else {
      n += 1
    }
    $('#analysisText').val(demoTextList[n])
    this.analysis(true)
  },
  // 检查文本框输入内容
  checkTextarea: function () {
    var text = $('#analysisText').val().trim()
    var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
    if (text === '') {
      $.alerts.alert('您没有输入内容')
      return false
    } else if (text.length > 100) {
      $.alerts.alert('最多输入100字')
      return false
    } else if (!reg.test(text)) {
      $.alerts.alert('抱歉，仅支持中文内容分析')
      return false
    } else {
      return String(text)
    }
  },
  addEvent: function () {
    var that = this
    // 更换示例
    $(document).on('click', '#changText', function () {
      that.changeDemo()
    })
    // 分词&词性点击效果
    $(document).on('click', '#participleAndPart li', function (e) {
      let $this = $(e.currentTarget)
      let $parent = $this.parent()
      let $parentSiblingsUl = $parent.siblings('ul')
      let code = $this.data('code')
      if (!$this.hasClass('select')) {
        $this.parent().find('li').removeClass('select')
        $this.addClass('select')
        $parentSiblingsUl.find('li').removeClass('select')
        $parentSiblingsUl.find('.' + code).addClass('select')
      }
    })
  },
  init: function () {
    var that = this
    $('#analysisText').val(demoTextList[n])
    that.analysis(true)
    that.geetestApi1()
    that.addEvent()
  }
}

$(function () {
  serviceTopbar()
  functionalExperienceModel.init()
})



// WEBPACK FOOTER //
// ./src/js/entry/services/keyword-extraction.js